export default {
  mounted() {
    this.timeoutScrolled = null
    this.$bus.$on('scroll-to-order', this.onScrollToOrder)
  },
  beforeDestroy() {
    this.$bus.$off('scroll-to-order', this.onScrollToOrder)
    window.clearTimeout(this.timeoutScrolled)
    this.timeoutScrolled = null
  },
  methods: {
    onScrollToOrder(orderId) {
      const orderLink = document.getElementById(`order-id__${orderId}`)
      const srolledTrs = document.querySelectorAll('.scrolled')
      for (let i = 0; i < srolledTrs.length; i++) {
        srolledTrs[i].classList.remove('scrolled')
      }
      if (orderLink) {
        const trEl = orderLink.closest('tr')
        const container = this.$refs.table.$el.querySelector('.vgt-responsive')
        if (trEl && container) {
          this.$scrollTo(trEl, 300, {
            container: container,
            offset: -40,
          })
          trEl.classList.add('scrolled')
          clearTimeout(this.timeoutScrolled)
          this.timeoutScrolled = setTimeout(() => {
            if (trEl) {
              trEl.classList.remove('scrolled')
            }
          }, 5000)
        }
      }
    }
  }

}